export enum Area {
  BECAS = 'BECAS',
  BECAS_NACIONALES = 'BECAS_NACIONALES',
  BECAS_EXTRANJERO = 'BECAS_EXTRANJERO',
  BECAS_POSDOC = 'BECAS_POSDOC',
  SNI = 'SNI',
  TODAS = 'TODAS',
  POSGRADOS = 'POSGRADOS',
  EXBECARIOS = 'EXBECARIOS',
  GPLN = 'GPLN',
  APOYOS_COMPLEMENTARIOS_BN = 'APOYOS_COMPLEMENTARIOS_BN',
}

/**
 * Función para convertir un string en un valor del enum.
 */
export default function asignarArea(areaString: string): Area | undefined {
  if (Object.values(Area).includes(areaString as Area)) {
    return areaString as Area;
  }
  return null;
}
